import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'sso-callback-app-root',
  templateUrl: './sso-callback-app.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class SsoCallbackAppComponent implements OnInit {
  ngOnInit(): void {
    if (window.opener) {
      window.opener.postMessage('sso-login-success', window.location.origin);
      window.close();
    }
  }
}
